export const ROLES = {
  ADMIN: 'ADMIN',
  TUTOR: 'TUTOR',
  PARENT: 'PARENT',
};

export const roleLabels = {
  [ROLES.ADMIN]: 'Адміністратор',
  [ROLES.TUTOR]: 'Репетитор',
  [ROLES.PARENT]: 'Батьки',
};



